import type { FunctionComponent } from 'react';

type LanguageSkillIconProperties = {
    readonly variant: 'feedback' | 'job-architecture' | 'job-profile';
};
export const LanguageSkillIcon: FunctionComponent<LanguageSkillIconProperties> = ({ variant }) => {
    return (
        <svg fill="none" height="16" style={{ flexShrink: 0 }} viewBox="0 0 16 8" width="16">
            <rect
                fill={variant === 'job-profile' || variant === 'feedback' ? '#040F16' : '#FF6C00'}
                height="8"
                width="16"
            />
        </svg>
    );
};
